import { InspectionStatus } from 'api';
import { formatInspectionStatus } from 'features';
import { Chip } from 'ui';

const getColor = (status: InspectionStatus) => {
  switch (status) {
    case 'BL':
      return 'default';
    case 'PL':
      return 'primary';
    case 'SC':
      return 'secondary';
    case 'CO':
      return 'success';
    case 'CA':
      return 'error';
    default:
      return 'default';
  }
};
export const InspectionStatusChip = ({ status }: { status: InspectionStatus }) => {
  return <Chip size="small" label={formatInspectionStatus(status)} color={getColor(status)} />;
};
